
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class OwnershipBasisDialog extends Serenity.EntityDialog<OwnershipBasisRow, any> {
        protected getFormKey() { return OwnershipBasisForm.formKey; }
        protected getIdProperty() { return OwnershipBasisRow.idProperty; }
        protected getLocalTextPrefix() { return OwnershipBasisRow.localTextPrefix; }
        protected getNameProperty() { return OwnershipBasisRow.nameProperty; }
        protected getService() { return OwnershipBasisService.baseUrl; }

        protected form = new OwnershipBasisForm(this.idPrefix);

    }
}